import { useState } from "react";
import BackPage from "../common/BackPage";
import { Box, Button, Grid, Paper } from "@mui/material";
import { BaseDialog } from "../common/BaseDialog";
import { CreatePlan } from "../createPlan";
import { PaypalCredentials } from "../paypalCredentials";
import { ManagePlanList } from "../managePlanList";
import { CreatePromoDiscount } from "../createPromoDiscount";

const styles = {
  titleSx: {
    fontWeight: "bold",
  },
  actionSx: {
    justifyContent: "center",
  },
  contentSx: { textAlign: "center", color: "var(--fx-surface-text, #0F172A)", display: "flex", justifyContent: "center", alignItems: "center" },
  btnCloseSx: {
    backgroundColor: "grey",
    color: "white",
    "&:hover": { backgroundColor: "var(--fx-surface-sidebar, #233044)" },
    margin: "0 8px",
  },
  btnAcceptSx: {
    backgroundColor: "#3c7cde",
    color: "white",
    "&:hover": { backgroundColor: "var(--fx-surface-sidebar, #233044)" },
    margin: "0 8px",
  },
};

export const PaymentsLayout = ({ currPage = "/" }) => {
  const [openCreatePlan, setOpenCreatePlan] = useState(false);
  const [openCreatePromo, setOpenCreatePromo] = useState(false);

  return (
    <Box>
      <BackPage currPage={currPage}></BackPage>
      <Grid container spacing={1} sx={{ height: "100vh", p: 5 }}>
        {/* First Column */}
        <Grid item xs={12} lg={6} p={4} width={400} >
          <Paper sx={{ padding: 2, width: "100%", textAlign: "center", height: "80vh", }}>
            <ManagePlanList></ManagePlanList>

          </Paper>
        </Grid>

        {/* Second Column */}
        <Grid item xs={12} lg={6} container spacing={1} direction="column" p={2} sx={{ height: "100vh" }}>
          {/* First Row in Second Column */}
          <Grid item xs={3}>
            <PaypalCredentials></PaypalCredentials>
          </Grid>

          {/* Second Row in Second Column */}
          <Grid item xs={3} sx={{ display: "flex", alignContent: "center", alignItems: "center" }}>
            <Paper sx={{ width: "600px", height: "auto", pt: 15, pb: 14, display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
              <Button onClick={() => setOpenCreatePromo(true)}>Add promo discount</Button>
              <Button onClick={() => setOpenCreatePlan(true)}>Create plan</Button>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <BaseDialog fullWidth={true} maxWidth={"lg"} openState={openCreatePlan} setOpenState={setOpenCreatePlan} content={<CreatePlan></CreatePlan>} contentSx={styles.contentSx} />
      <BaseDialog fullWidth={true} maxWidth={"lg"} openState={openCreatePromo} setOpenState={setOpenCreatePromo} content={<CreatePromoDiscount></CreatePromoDiscount>} contentSx={styles.contentSx} />
    </Box>
  );
};
